import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

if (document.querySelector('.BestProductsSlider')) {
    const bpSlider = new Swiper('.BestProductsSlider .swiper', {
        modules: [Navigation, Autoplay],
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
        autoplay: {
            delay: 4500,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: '.BestProductsSlider__btn-next',
            prevEl: '.BestProductsSlider__btn-prev',
        },
    });
}
